import getScopedPath from 'owa-url/lib/getScopedPath';
import joinPath, { ensureLeadingSlash } from 'owa-url/lib/joinPath';
import { getOwaCanaryCookie } from 'owa-service/lib/canary';
import { getConfig } from 'owa-service/lib/config';
import {
    getApp,
    getOwsPath,
    getHostAppEcsFilter,
    getHostedUxEcsFilter,
    getHostedScenario,
} from 'owa-config';

export async function postLanguageTimeZone(
    timeZone: string,
    language: string,
    emailAddress?: string,
    authToken?: string
): Promise<Response> {
    const scopedPath = getScopedPath(getOwsPath());
    const languagePostEndpoint = ensureLeadingSlash(
        `${joinPath(scopedPath, 'lang.owa')}?app=${getApp()}`
    );
    const languagePostHeaders = new Headers();
    const languagePostBody = `localeName=${language}&tzid=${timeZone}&saveLanguageAndTimezone=1`;
    const serviceConfig = getConfig();

    languagePostHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    languagePostHeaders.append('X-OWA-CANARY', getOwaCanaryCookie());

    if (emailAddress) {
        languagePostHeaders.append('x-anchormailbox', emailAddress);
    }

    if (!authToken && !!serviceConfig && serviceConfig.getAuthToken) {
        authToken = await serviceConfig.getAuthToken();
    }

    if (authToken) {
        languagePostHeaders.append('Authorization', authToken);
    }

    var hostedUx = getHostedUxEcsFilter();

    // we set the x-owa-host-app header only if the hostedUx is true
    if (hostedUx == 'true') {
        languagePostHeaders.append('x-owa-hosted-ux', hostedUx);
        // Undefined is the default value
        languagePostHeaders.append('x-owa-host-app', getHostAppEcsFilter() || 'undefined');

        const hostedScenario = getHostedScenario();
        if (hostedScenario) {
            languagePostHeaders.append('x-owa-hosted-scenario', hostedScenario);
        }
    }

    return fetch(languagePostEndpoint, {
        method: 'POST',
        credentials: 'include',
        headers: languagePostHeaders,
        body: languagePostBody,
    });
}
